import { Card, Col, Flex, Row, Typography } from "antd";
import { AlertOutlined, FallOutlined, RiseOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

function AlarmsHighlightCard({ currentValue = 0, lastValue = 0 }) {
  const numberFormat = { maximumFractionDigits: 0, minimumFractionDigits: 0 };

  return (
    <Card
      title={
        <Title level={5} style={{ margin: 0 }}>
          <AlertOutlined style={{ marginRight: 12 }} />
          Warnings and Alarms
        </Title>
      }
      size="small"
      bordered
    >
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Flex justify="start" align="end" gap={8}>
            <Title level={2} style={{ margin: 0 }}>
              {currentValue
                ? currentValue.toLocaleString("en-US", numberFormat)
                : currentValue === 0
                ? currentValue
                : " - "}
            </Title>
          </Flex>
        </Col>
        {/* <Col span={24}>
                    <Flex justify='end' align='center' gap={8}>
                        <Title level={4} style={{ margin: 0 }} type={ lastValue > currentValue ? 'success' : 'danger'}> {lastValue > currentValue ? <FallOutlined /> : <RiseOutlined />}
                        </Title>
                        <Text italic>Last : { lastValue? lastValue.toLocaleString("en-US", numberFormat) + ' ' : ' - '} 
                        ( { 
                            currentValue? lastValue? ((currentValue - lastValue) / lastValue).toLocaleString('en-US', { maximumFractionDigits: 1, style: 'percent' }) : ' - %': ' - %'
                        } )
                        </Text>
                    </Flex>
                </Col> */}
      </Row>
    </Card>
  );
}

export default AlarmsHighlightCard;
